import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=470f3146&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=470f3146&prod&lang=css"
import style1 from "./edit.vue?vue&type=style&index=1&id=470f3146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f3146",
  null
  
)

export default component.exports